import React, { useEffect } from "react";
import Auth from "@aws-amplify/auth";
import { setAccessToken, setJwtToken } from "./../revampCRUD/axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import moment from "moment";

toast.configure();

//quiz
export const ADMIN_EMAIL = "olympus@codeops.tech"; //'manjunath.r@knownshare.in';
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const OWNER = "owner";
export const COLLABORATOR = "collaborator";
export const READER = "reader";
export const SOFT_DELETED = "soft-deleted";
export const ENDED = "ended";
export const ABANDONED = "abandoned";
export const PENDING = "pending";
export const STARTED = "started";
export const REGULAR = "regular";

export const accessType = [
	{ value: 1, label: "Collaborator (All Access - Same as Owner)" },
	{ value: 2, label: "Reader (Limited Access - View, No Edit & No Delete)" },
];

export const pgMethods = {
	1: "RAZORPAY",
	2: "STRIPE",
	3: "OPENBANK",
	4: "PHONEPE",
	5: "TAP",
};

export const getStatus = (
	startDateTime,
	endDateTime,
	status = "",
	mode = "",
) => {
	if (status === "pending") return "Upcoming";
	if (status === "started") return "Live";
	if (status === "ended" || status === "abandoned") return "Expired";
	if (status === "soft-deleted") return "Deleted";
	if (moment().isAfter(moment.utc(endDateTime).local())) return "Expired";
	if (
		moment().isBetween(
			moment.utc(startDateTime).local(),
			moment.utc(endDateTime).local(),
		)
	)
		return "Live";
	else return "Upcoming";
};

export const makeCSV = (content) => {
	let csv = "";
	content.forEach((value) => {
		value.forEach((item, i) => {
			let innerValue = !item ? "" : item.toString();
			let result = innerValue.replace(/"/g, '""');
			if (result.search(/("|,|\n)/g) >= 0) {
				result = '"' + result + '"';
			}
			if (i > 0) {
				csv += ",";
			}
			csv += result;
		});
		csv += "\n";
	});
	return csv;
};

export const logout = async () => {
	try {
		localStorage.removeItem("jwtToken");
		localStorage.removeItem("userEmail");
		localStorage.removeItem("userName");
		localStorage.removeItem("user");
		localStorage.removeItem("eventId");
		setJwtToken("");
		setAccessToken("");
		// await Auth.signOut();
		await Auth.signOut({ global: true });
	} catch (err) {
		console.log(err);
	}
};

export const successToaster = (message, autoClose = 5000) => {
	toast.success(message, {
		position: "top-right",
		autoClose: autoClose,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
	});
};

export const errorToaster = (message, autoClose = 5000) => {
	toast.error(message, {
		position: "top-right",
		autoClose: autoClose,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
	});
};

export const clickOutside = (ref, onClickOutside) => {
	// Function to close dropdown when clicked anywhere outside
	useEffect(() => {
		/**
		 * Invoke Function onClick outside of element
		 */
		function handleClickOutside(event) {
			if (ref.current && !ref?.current?.contains(event.target)) {
				onClickOutside();
			}
		}
		// Bind
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// dispose
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, onClickOutside]);
};

// A custom hook that builds on useLocation to parse the query string for you.
export function useQuery() {
	const { search } = useLocation();

	const params = Object.fromEntries(
		React.useMemo(() => new URLSearchParams(search), [search]),
	);

	return params;
}

export const regexMethods = {
	//This is used for certaing regex operation
	allowOnlyPositiveNumber: (evt) => {
		let charCode = String.fromCharCode(evt.which);
		if (!/[0-9]/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	allowAlphaNumeric: (evt) => {
		let charCode = String.fromCharCode(evt.which);
		if (!/^[a-z0-9-]+/i.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	allowAlphaNumericAndSpecial: (evt) => {
		//alphanumeric and accpet special characters :- @, &, #, $, !, (, ), *
		let charCode = String.fromCharCode(evt.which);
		if (!/^[a-zA-Z0-9@&#$!()*-]+$/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
	noSpaces: (evt) => {
		let charCode = String.fromCharCode(evt.which);
		if (!/^\S*$/.test(charCode)) {
			evt.preventDefault();
		}
		return;
	},
};
